import {connect} from 'react-redux'
import * as actTransaction from 'actions/reports/transactions'
import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import {rupiah} from 'utils/formatter'
import styles from './oldRefundTransactionModal.css'
import * as mpReportsTransactions from 'mixpanel/reports/transactions'
import {formValueSelector} from 'redux-form'

class OldRefundTransactionModal extends React.Component {
  constructor (props) {
    super(props)
    let {transactionDetail} = props.data.reports.transactions
    let amountToRefund = transactionDetail.total_collected - transactionDetail.total_refund

    this.state = {
      amount: amountToRefund,
      reason: '',
      otherReason: ''
    }
  }

  render () {
    let {openOldRefundModal} = this.props.data.reports.transactions
    return <Modal show={openOldRefundModal} onHide={this._onHide} bsClass='full-height-modal margin-top-modal modal'>
      <ModalHeader title='Issue Refund' />
      <Modal.Body>
        <div className='row'>
          <div className='col-md-12' style={{textAlign: 'center'}}>
            {rupiah(this.state.amount)} should be tendered in cash upon refund.
          </div>
          <div className='col-md-6'>
            <input className={`form-control ${styles['amount-reason']}`} onChange={this._onChangeAmount} value={this.state.amount} />
          </div>
          <div className='col-md-6'>
            <select className={`form-control ${styles['select-reason']}`} onChange={this._onChangeReason} value={this.state.reason}>
              <option value=''>- Select Reason -</option>
              <option value='Returned Goods'>Returned Goods</option>
              <option value='Accidental Charge'>Accidental Charge</option>
              <option value='Cancelled Order'>Cancelled Order</option>
              <option value='Other'>Other</option>
            </select>
          </div>
          {this.state.reason === 'Other' && <div className={'col-md-12 ' + styles['reason-field']}>
            <input className={`form-control ${styles['reason-for-refund']}`} placeholder='Reason for refund' onChange={this._onChangeOtherReason} value={this.state.otherReason} />
          </div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className='btn btn-default mr-10px pull-left' onClick={this._onHide} type='button'>Cancel</button>
        <button className='btn btn-primary pull-right'
          disabled={!this._canIssueRefund()}
          type='button'
          onClick={this._onClickIssueRefund}
        >Issue Refund</button>
      </Modal.Footer>
    </Modal>
  }

  _onChangeAmount = (e) => {
    let {transactionDetail} = this.props.data.reports.transactions
    const amountToRefund = transactionDetail.total_collected - transactionDetail.total_refund
    if (!e.target.value) {
      this.setState({amount: 0})
    } else if (isNaN(e.target.value)) {
      return false
    } else if (e.target.value < 0) {
      this.setState({amount: 0})
    } else if (e.target.value > amountToRefund) {
      this.setState({amount: amountToRefund})
    } else {
      this.setState({amount: parseInt(e.target.value)})
    }
  };

  _onChangeReason = (e) => {
    this.setState({reason: e.target.value})
  };

  _onChangeOtherReason = (e) => {
    this.setState({otherReason: e.target.value})
  };

  _onClickIssueRefund = () => {
    let {transactionDetail} = this.props.data.reports.transactions
    const {search} = this.props
    const maxAmountToRefund = transactionDetail.total_collected - transactionDetail.total_refund
    let data = {
      refund: {
        'amount': this.state.amount,
        'reason': this.state.reason !== 'Other' ? this.state.reason : this.state.otherReason,
        'payment_id': transactionDetail.id,
        'custom_reason': this.state.otherReason
      }
    }
    mpReportsTransactions.reportsTransactionRefund({
      amount: this.state.amount,
      isFullRefund: (this.state.amount === maxAmountToRefund),
      outletIds: search.outlet,
      startDate: search.date.startDate,
      endDate: search.date.endDate
    })
    this.props.dispatch(actTransaction.issueOldRefundRequest(data))
  };

  _onHide = () => {
    const {transactionDetail} = this.props.data.reports.transactions
    const amountToRefund = transactionDetail.total_collected - transactionDetail.total_refund
    this.setState({amount: amountToRefund, reason: '', otherReason: ''})
    this.props.dispatch(actTransaction.hideOldRefundModal())
  }

  _canIssueRefund = () => {
    return (this.state.reason && (this.state.reason !== 'Other' || this.state.otherReason))
  }
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  }
}

export default connect(mapStateToProps)(OldRefundTransactionModal)



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/OldRefundTransactionModal/OldRefundTransactionModal.js